"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDeviceType = exports.deviceTypes = void 0;
var _componentUtilities = require("@ux/component-utilities");
// SERP defined device types.
const deviceTypes = exports.deviceTypes = {
  MOBILE: 'mobile',
  TABLET: 'tablet',
  DESKTOP: 'desktop',
  PHABLET: 'phablet',
  LARGE: 'large',
  XLARGE: 'xlarge'
};
const useDeviceType = () => {
  const {
    breakpoint
  } = (0, _componentUtilities.useBreakpoints)(deviceTypes.MOBILE, deviceTypes.TABLET, deviceTypes.DESKTOP);
  let deviceType;
  let isMobile = false;
  let isTablet = false;
  let isDesktop = false;
  if (breakpoint === deviceTypes.TABLET) {
    deviceType = deviceTypes.TABLET;
    isTablet = true;
  } else if (breakpoint === deviceTypes.PHABLET || breakpoint === deviceTypes.MOBILE) {
    deviceType = deviceTypes.MOBILE;
    isMobile = true;
  } else if (breakpoint === deviceTypes.LARGE || breakpoint === deviceTypes.DESKTOP || breakpoint === deviceTypes.XLARGE) {
    deviceType = deviceTypes.DESKTOP;
    isDesktop = true;
  }
  return {
    breakpoint,
    deviceType,
    isDesktop,
    isMobile,
    isTablet
  };
};
exports.useDeviceType = useDeviceType;